import React from 'react'
import { HiOutlineAcademicCap } from 'react-icons/hi'
import styles from './styles.module.css'

export default function SchoolSelect({ value, onChange, schools, loading, error }) {
    return (
        <div>
            <div className={styles.wrapper} style={error ? { borderColor: 'red' } : undefined}>
                <HiOutlineAcademicCap className={styles.icon} />
                <select
                    className={styles.select}
                    value={value}
                    onChange={onChange}
                    disabled={loading}
                >
                    <option value=''>
                        {loading ? 'Загрузка...' : 'Выберите школу'}
                    </option>
                    {schools.map(school => (
                        <option key={school.id} value={school.id}>
                            {school.name}
                        </option>
                    ))}
                </select>
            </div>
            {error && <p className={styles.errorText}>{error}</p>}
        </div>
    )
}
